/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _region = _interopRequireDefault(require("../region"));
_region.default.align = function (sourceRegion, targetRegion, align) {
  targetRegion = _region.default.from(targetRegion);
  align = (align || 'c-c').split('-');
  if (align.length != 2) {
    console.warn("Incorrect region alignment! The align parameter need to be in the form 'br-c', that is, a - separated string!", align);
  }
  return _region.default.alignToPoint(sourceRegion, targetRegion.getPoint(align[1]), align[0]);
};
_region.default.alignToPoint = function (region, point, anchor) {
  region = _region.default.from(region);
  var sourcePoint = region.getPoint(anchor);
  var count = 0;
  var shiftObj = {};
  if (sourcePoint.x != null && point.x != null) {
    count++;
    shiftObj.left = point.x - sourcePoint.x;
  }
  if (sourcePoint.y != null && point.y != null) {
    count++;
    shiftObj.top = point.y - sourcePoint.y;
  }
  if (count) {
    region.shift(shiftObj);
  }
  return region;
};


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/region-align/Region.static.js
// module id = 768
// module chunks = 0